import React from 'react';
import { DoodleBurst, DoodleHeart, DoodleStar } from '../brand/Doodles';
import type { BcmLeader } from '../../data/leadership';
const accents = ['bg-brand-blue', 'bg-brand-yellow', 'bg-brand-tan', 'bg-brand-pink'] as const;
function initials(name: string) {
  return name.split(' ').map(part => part.charAt(0)).join('').slice(0, 2).toUpperCase();
}
function Shape({
  index
}: {
  index: number;
}) {
  const which = index % 3;
  if (which === 0) return <DoodleStar className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-22" data-mp="2w7u0ob8h801k" />;
  if (which === 1) return <DoodleBurst className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-23" data-mp="2w9na1yah4yd9" />;
  return <DoodleHeart className="h-8 w-8" color="var(--bcm-dark-blue)" data-id="element-24" data-mp="315c27gk5zczj" />;
}

/**
 * Branded role card. When `leader.photo` is supplied the real photo replaces the
 * initials placeholder — no stock headshots or generated faces are ever used.
 */
export function LeaderCard({
  leader,
  index
}: {
  leader: BcmLeader;
  index: number;
}) {
  return <article className="flex h-full flex-col overflow-hidden rounded-[22px] border-2 border-brand-navy bg-white" data-id="element-25" data-mp="vyr2omc9bur0">
      {leader.photo ? <img src={leader.photo} alt={`${leader.name}, ${leader.role} at UCF BCM`} loading="lazy" className="aspect-square w-full border-b-2 border-brand-navy object-cover" data-id="element-26" data-mp="ry79ftut1ba5" /> : <div className={`flex aspect-square w-full flex-col items-center justify-center gap-2 border-b-2 border-brand-navy ${accents[index % accents.length]}`} data-id="element-27" data-mp="i12ilgq0krn0">
          <span aria-hidden="true" data-id="element-28" data-mp="8726guwbem4s">
            <Shape index={index} data-id="element-29" data-mp="471tzfss0l0d" />
          </span>
          <span aria-hidden="true" className="font-display text-3xl font-extrabold tracking-tight text-brand-navy" data-id="element-30" data-mp="47tbxntgak86">
            {initials(leader.name)}
          </span>
        </div>}
      <div className="p-5" data-id="element-31" data-mp="3lforpxm475xx">
        <h3 className="font-display text-lg font-bold leading-snug text-brand-navy" data-id="element-32" data-mp="3lfeze3dlkmp2">
          {leader.name}
        </h3>
        <p className="mt-1 font-meta text-[12px] font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-33" data-mp="3brb56fdgfjdz">
          {leader.role}
        </p>
      </div>
    </article>;
}